import style from "../../../../assets/scss/sub/topBanner.module.scss";

interface Args {
    icon: string;
    title: string;
    countUnit: string;
    count?: number | string;
    subCounts?: {
        icon?: string;
        count?: number;
    }[];
}

export function CountContainer(
    {icon, subCounts, count, countUnit, title,}: Args
) {

    return (
        <>
            <div className={style.countContainer}>
                <div className={style.docIcon}>
                    <img src={icon} className={style.iconImg} alt={icon}/>
                </div>
                <div className={style.textArea}>
                    <div className={subCounts ? style.textTitle3 : style.textTitle2}>{title}</div>
                    {count !== undefined && (
                        <div className={style.numberText}>{count}{countUnit}</div>
                    )}
                    {subCounts && (
                        <div className={`${style.numberText} ${style.mobileNumberText}`}>
                            {subCounts.map((subCount, index) => (
                                <div key={index} className={style.couponContainer}>
                                    {subCount.icon && (
                                        <img
                                            src={subCount.icon}
                                            className={style[`${subCount.icon === 'kIcon' ? 'kIcon' : 'dIcon'}`]}
                                            alt={subCount.icon}
                                        />
                                    )}
                                    <span className={style.numberText}>
                                      {subCount.count ?? 0}{countUnit}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            {!subCounts && (<div className={style.verticalLine}></div>)}

        </>
    )
}